export default __webpack_public_path__ + "static/media/catalog.a57273fa.png";